import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClienteDetalharJanelaComponent } from './cliente-detalhar-janela.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:':id', component: ClienteDetalharJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ClienteDetalharJanelaRoutingModule { }
